import GenericPerson from "../assets/images/staff/missing_staff.png";
import MargotPerson from "../assets/images/staff/margo.jpg";
import GerouldPerson from "../assets/images/staff/gerould.jpg";
import Laura from "../assets/images/staff/laura.jpg";

interface StaffListType {
  image: string;
  name: string;
  position: string;
}

const StaffList: StaffListType[] = [
  {
    image: MargotPerson,
    name: "Margot Mazur",
    position: "Executive Director, Creative Director",
  },
  {
    image: GerouldPerson,
    name: "Dr. Gerould Wilhelm",
    position: "Director of Research",
  },
  {
    image: Laura,
    name: "Laura Anchor",
    position: "Wildlife Biologist & Bee Taxonomist",
  },
];

export type { StaffListType };
export { StaffList };
